<template>
  <div>
    <div v-show="!!params.data.fileId && params.data.type === 6">
      <el-button type="text" plain @click="downloadSopEmail">{{ $t('CargoMsg.Cargo_InvoiceHistoryEmail') }}</el-button>
    </div>
    <div v-show="!!params.data.fileId && params.data.type !== 5 && params.data.type !== 6">
      <el-button type="text" plain @click="downloadSopEmail">Sop{{ $t('Viewer.email') }}</el-button>
    </div>
    <div v-show="!!params.data.fileId && params.data.type === 5">
      <el-button type="text" plain @click="downloadSopEmail">{{ $t('CargoMsg.Cargo_FileHistory') }}{{ $t('Viewer.email') }}</el-button>
    </div>
  </div>
</template>
<script>
import { getToken } from '@/utils/auth' // get token from cookie
import { cacheName, cache } from '@/utils/cacheManager'
export default {
  name: 'SopEmailOptBtn',
  data() {
    return {
      url: ''
    }
  },
  mounted() {
    // http://stage.cargoware.com/storage/services // http://storage.walltechsystem.cn/services/file/open/
  },
  methods: {
    async downloadSopEmail() {
      await cache.load(cacheName.CONFIG)
      const storageConfigURL = cache.config.get('StorageURL')
      console.log('downloadSopEmail storageConfigURL', storageConfigURL)
      window.open((storageConfigURL || this.params.data.emailUrlPrefix) + '/file/open/' + this.params.data.fileId + '?sessionId=' + getToken())
    }
  }
}
</script>
<style lang="scss" scoped>
div a{
  color:blue;
  &:hover{
    color:red
  }
}
</style>
